import { QRCodeCanvas } from "qrcode.react";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./ControllerQRCodeDialog.style";
import { OTHER_CONTROLLERS_FAQ_URL } from "../../../constants/controllerInstruction";

type TControllerQRCodeDialog = {
  onClose?: () => void;
  open: boolean;
};

const ControllerQRCodeDialog: React.FC<TControllerQRCodeDialog> = (props) => {
  const { open, onClose } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      mainAction={{
        text: "Ok",
        onClick: onClose,
        id: "close-dialog",
        "data-gamepad": "default-selected",
        size: "large",
      }}
      className={classes.dialog}
    >
      <div className={classes.otherControllersContent}>
        <Typography
          variant={TypographyVariant.HeadingH3Bold}
          color={TypographyColor.Default}
        >
          Connection Guide
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Medium}
          color={TypographyColor.Default}
        >
          Please scan the QR code below to learn more about how to connect with
          controllers
        </Typography>
        <QRCodeCanvas
          value={OTHER_CONTROLLERS_FAQ_URL}
          size={138}
          className={classes.qrCode}
          level="L"
          marginSize={3}
        />
      </div>
    </Dialog>
  );
};

export default ControllerQRCodeDialog;
